import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useCanPage } from '../hooks/usePermission';

/**
 * Route-level gate. The backend refuses the data regardless — this exists so a user
 * lands on a clear message instead of an empty screen full of failed requests.
 */
export function RequirePermission({ page, children }: { page: string; children: ReactNode }) {
  const allowed = useCanPage(page);
  if (allowed) return <>{children}</>;
  return (
    <div className="mx-auto max-w-md py-24 text-center">
      <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-bronze-50"><Lock className="h-5 w-5 text-bronze-500" /></div>
      <h2 className="display mt-5 text-[28px] text-ink-900">This page isn't in your role</h2>
      <p className="mt-2 text-[13.5px] leading-relaxed text-ink-500">
        Your role doesn't include any permission on <code className="rounded bg-ink-100 px-1.5 py-0.5 text-[12px] text-ink-700">{page}</code>. An administrator can grant it under Roles &amp; permissions.
      </p>
      <Link to="/app" className="mt-6 inline-block text-[13px] font-medium text-bronze-600 hover:underline">Back to your dashboard</Link>
    </div>
  );
}
